import { render, staticRenderFns } from "./WineListAddProduct.vue?vue&type=template&id=688dd8d9&scoped=true&"
import script from "./WineListAddProduct.vue?vue&type=script&lang=js&"
export * from "./WineListAddProduct.vue?vue&type=script&lang=js&"
import style0 from "./WineListAddProduct.vue?vue&type=style&index=0&id=688dd8d9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "688dd8d9",
  null
  
)

export default component.exports